<div class="container">
    <div class="row closingPriceDataWrap">
        <div class="col-md-12">
            <h5 class="rps-heading-five">Closing price</h5>
            <p class="caption rps-paragraph-two rps-grey" *ngIf="priceModel && priceModel.price && priceModel.price.currentPrice && priceModel.price.currentPrice.dailyPrice" data-rpa-tag-id="closingPriceDate">
                Closing price as of {{ priceModel.price.currentPrice.dailyPrice.regular.asOfDate | ESTPipe }}</p>
        </div>
    </div>
</div>
<div class="" *ngIf="priceModel && priceModel.price">
    <div class="row">
        <div class="col-lg-3 col-sm-4 col-xs-2 col-6" *ngIf="priceModel.profile.isETF">
            <div class="cell">
                <p class="rps-paragraph-two"><a role="button" tabindex="0" class="link marketPriceLink dialog-button" (click)="setDialogInfo('Market price','','');closingPriceModalDialog.openModalDialog();" href="javascript:void(0)">Market price</a>
                </p>
                <h4 class="rps-heading-four" data-rpa-tag-id="pr-cp-mkt-price">${{priceModel.price.currentPrice.dailyPrice.market.price ?
                    priceModel.price.currentPrice.dailyPrice.market.price : '&mdash;' }}</h4>
            </div>
        </div>

        <div class="col-lg-3 col-sm-4 col-xs-2 col-6" *ngIf="priceModel.profile.isETF">
            <div class="cell">
              <p class="rps-paragraph-two">Market price change</p>
              <div class="price-data-wrap">
                <c11n-icon
                  class="value-change-icon"
                  data-rpa-tag-id="arrowMarket"
                  *ngIf="priceModel.price.currentPrice.dailyPrice.market.priceChangeAmount > 0 || priceModel.price.currentPrice.dailyPrice.market.priceChangeAmount < 0"
                  [name]="priceModel.price.currentPrice.dailyPrice.market.priceChangeAmount | valueChange : 'name'"
                  [size]="'small'"
                  [altText]="priceModel.price.currentPrice.dailyPrice.market.priceChangeAmount | valueChange : 'altText'">
                </c11n-icon>
                <span class="vg-heading-four--regular" data-rpa-tag-id="priceChangeMarket_percentChangeMarket">{{priceModel.price.currentPrice.dailyPrice.market ?
                    (priceModel.price.currentPrice.dailyPrice.market.priceChangeAmount| currency:'USD':'symbol':'1.2-2') :
                    '&mdash;'}}
                    ({{priceModel.price.currentPrice.dailyPrice.market?.priceChangePct}}{{priceModel.price.currentPrice.dailyPrice.market?.priceChangePct?'%':'&mdash;'}})
                </span>
              </div>
            </div>
        </div>

        <div [ngClass]="priceModel.profile.is529 ? 'col-lg-5':'col-lg-2'"  class="col-sm-4 col-xs-2 col-6">
            <div class="cell">
                <p class="rps-paragraph-two" *ngIf="priceModel.profile.isMutualFund ||  priceModel.profile.isETF">NAV</p>
                <p class="rps-paragraph-two" *ngIf="priceModel.profile.is529">Unit price</p>
                <h4 class="rps-heading-four"
                data-rpa-tag-id="pr-cp-nav-price">${{priceModel.price.currentPrice.dailyPrice.regular.price ?
                    priceModel.price.currentPrice.dailyPrice.regular.price : '&mdash;' }}</h4>
            </div>
        </div>
        <div [ngClass]="priceModel.profile.isETF ? 'col-lg-4' : priceModel.profile.is529 ? 'col-lg-7':'col-lg-3'"  class="col-sm-4 col-xs-2 col-6">
            <div class="cell">
                <p class="rps-paragraph-two" *ngIf="priceModel.profile.isMutualFund ||  priceModel.profile.isETF">NAV change</p>
                <p class="rps-paragraph-two" *ngIf="priceModel.profile.is529">Unit price change</p>
                <div class="price-data-wrap">
                  <c11n-icon
                    class="value-change-icon"
                    data-rpa-tag-id="arrowNAV"
                    *ngIf="priceModel.price.currentPrice.dailyPrice.regular.priceChangeAmount > 0 || priceModel.price.currentPrice.dailyPrice.regular.priceChangeAmount < 0"
                    [name]="priceModel.price.currentPrice.dailyPrice.regular.priceChangeAmount | valueChange : 'name'"
                    [size]="'small'"
                    [altText]="priceModel.price.currentPrice.dailyPrice.regular.priceChangeAmount | valueChange : 'altText'">
                  </c11n-icon>
                <span class="vg-heading-four--regular" data-rpa-tag-id="priceChangeNAV_pricePercentNAV">{{priceModel.price.currentPrice.dailyPrice.regular ?
                    (priceModel.price.currentPrice.dailyPrice.regular.priceChangeAmount| currency:'USD':'symbol':'1.2-2') :
                    '&mdash;'}}
                    ({{priceModel.price.currentPrice.dailyPrice.regular?.priceChangePct}}{{priceModel.price.currentPrice.dailyPrice.regular?.priceChangePct?'%':'&mdash;'}})
                </span>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-sm-4 col-xs-2 col-6" *ngIf="priceModel.profile.isETF">
            <div class="cell">
                <p class="rps-paragraph-two">30-day Median Bid/Ask spread</p>
                <h4 class="rps-heading-four" data-rpa-tag-id="medianBidAskSpread">{{fundAnalyticsModel ? (fundAnalyticsModel | number : '1.2-2') : '&mdash;' }}{{fundAnalyticsModel ? '%' : ''}}</h4>
            </div>
        </div>

        <div [ngClass]="priceModel.profile.isETF ? 'col-lg-3' : priceModel.profile.is529? 'col-lg-5':'col-lg-2'" class="col-sm-4 col-xs-2 col-6">
            <div class="cell">
                <p class="rps-paragraph-two">52-week High <sup *ngIf="priceModel.content.etfSplit">4</sup></p>
                <h4 class="rps-heading-four" data-rpa-tag-id="fiftyTwoHighPrice">{{priceModel.price.currentPrice.highLow.regular ?
                    (priceModel.price.currentPrice.highLow.regular.highPrice| currency:'USD':'symbol':'1.2-2') : '&mdash;'}}
                </h4>
                <p class="caption2 rps-paragraph-three rps-grey" *ngIf="priceModel.price.currentPrice.highLow.regular" data-rpa-tag-id="fiftyTwoHighPriceDate">as of {{ priceModel.price.currentPrice.highLow.regular.highDate | ESTPipe }}</p>
            </div>
        </div>

        <div [ngClass]="priceModel.profile.is529? 'col-lg-5':'col-lg-2'" class="col-sm-4 col-xs-2 col-6">
            <div class="cell">
                <p class="rps-paragraph-two">52-week Low <sup *ngIf="priceModel.content.etfSplit">4</sup></p>
                <h4 class="rps-heading-four" data-rpa-tag-id="fiftyLowHighPrice">{{priceModel.price.currentPrice.highLow.regular ?
                    (priceModel.price.currentPrice.highLow.regular.lowPrice| currency:'USD':'symbol':'1.2-2') : '&mdash;'}}
                </h4>
                <p class="caption2 rps-paragraph-three rps-grey" *ngIf="priceModel.price.currentPrice.highLow.regular"
                data-rpa-tag-id="fiftyLowHighPriceDate">as of {{ priceModel.price.currentPrice.highLow.regular.lowDate | ESTPipe }}</p>
            </div>
        </div>

        <div [ngClass]="priceModel.profile.isETF ? 'col-lg-4' : priceModel.profile.is529? 'col-lg-5':'col-lg-3'"  class="col-sm-4 col-xs-2 col-6">
            <div class="cell">
                <p class="rps-paragraph-two">52-week Difference</p>
                <h4 class="rps-heading-four" data-rpa-tag-id="fiftyTwoWeekDiff">{{priceModel.price.currentPrice.highLow.regular ?
                    (priceModel.price.currentPrice.highLow.regular.spreadPrice| currency:'USD':'symbol':'1.2-2') :
                    '&mdash;'}}
                    ({{priceModel.price.currentPrice.highLow.regular?.spreadPct}}{{priceModel.price.currentPrice.highLow.regular?.spreadPct?'%':'&mdash;'}})
                </h4>
            </div>
        </div>
        <div class="col-lg-3 col-sm-4 col-xs-2 col-6" *ngIf="priceModel && priceModel.profile && priceModel.profile.isETF">
            <div class="cell">
                <p class="rps-paragraph-two">Premium/Discount</p>
                <h4 class="rps-heading-four" data-rpa-tag-id="premium">{{priceModel.price.currentPrice.premiumOrDiscount ? (priceModel.price.currentPrice.premiumOrDiscount|
                    currency:'USD':'symbol':'1.2-2') : '&mdash;'}}</h4>
            </div>
        </div>


        <div class="col-lg-3 col-sm-4 col-xs-2 col-6" *ngIf="priceModel.profile.isETF">
            <div class="cell">
                <p class="rps-paragraph-two">25-day Avg Volume</p>
                <h4 class="rps-heading-four" data-rpa-tag-id="twentyFiveDayAvgVol">{{priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.volumemovingAverage25Day ?
                    (priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.volumemovingAverage25Day | number:'':'en'): '&mdash;' }}</h4>
            </div>
        </div>

        <div class="col-lg-2 col-sm-4 col-xs-2 col-6" *ngIf="priceModel.profile.isETF">
            <div class="cell">
                <p class="rps-paragraph-two">50-day Avg Volume</p>
                <h4 class="rps-heading-four" data-rpa-tag-id="fiftyDayAvgVol">{{priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.volumemovingAverage50Day ?
                    (priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.volumemovingAverage50Day | number:'':'en') : '&mdash;' }}</h4>
            </div>
        </div>

        <div class="col-lg-2 col-sm-4 col-xs-2 col-6 yield-size"*ngIf="priceModel?.profile?.isMutualFund || priceModel?.profile?.isETF || (priceModel?.profile?.is529 && priceModel?.profile?.fundFact?.isMoneyMarket)">
            <div class="cell">
                <p><a role="button" tabindex="0" data-rpa-tag-id="pr-cp-secYield-text" class="marketPriceLink dialog-button"  (click)="setDialogInfo('SEC yield','','');closingPriceModalDialog.openModalDialog();" href="javascript:void(0)">{{createDaysToken(priceModel.price?.currentPrice?.yield?.yieldNote)}} SEC yield<sup *ngIf="priceModel?.profile?.isExternalFund">{{priceModel?.secYieldNonVgFootNote?.id}}</sup></a></p>
                <h4 *ngIf="!priceModel.price.currentPrice.yield.yieldPct && priceModel.profile?.category !=='Real Estate'" data-rpa-tag-id="pr-cp-secYield-pct">{{priceModel.price.currentPrice.yield?.yieldPct}}{{priceModel.price.currentPrice.yield?.yieldPct?'%':'&mdash;'}}</h4>

                <h4 class="rps-heading-four" *ngIf="priceModel.price.currentPrice.yield.yieldPct && priceModel.profile?.category !=='Real Estate'">
                    <h4 class="rps-heading-four" *ngIf="staticTicker.indexOf(priceModel.profile?.ticker)>=0"> <a role="button" class="secYieldLink dialog-button"
                        (click)="setDialogInfo(priceModel.profile?.longName,priceModel.profile?.ticker,priceModel.profile?.fundId);closingPriceModalDialog.openModalDialog();"
                        href="javascript:void(0)" data-rpa-tag-id="pr-cp-secYield-pct">
                        {{priceModel.price.currentPrice.yield?.yieldPct}}{{priceModel.price.currentPrice.yield?.yieldPct?'%':'&mdash;'}}
                        </a></h4>
                <h4 class="rps-heading-four" *ngIf="staticTicker.indexOf(priceModel.profile?.ticker)<0" data-rpa-tag-id="pr-cp-secYield-pct">
                        {{priceModel.price.currentPrice.yield?.yieldPct}}{{priceModel.price.currentPrice.yield?.yieldPct?'%':'&mdash;'}}

                    </h4> &nbsp;
                <h4 class="yieldNote mark-pro-regular-bold rps-heading-four" *ngFor="let yieldNote of priceModel.price.currentPrice.yield.yieldNote">
                        <h4 class="rps-heading-four" > <a role="button" tabindex="0" class="link secYieldLink"
                                (click)="setDialogInfo(priceModel.profile.longName,yieldNote.footnoteText,yieldNote.footnoteCode);closingPriceModalDialog.openModalDialog();" href="javascript:void(0)" data-rpa-tag-id="pr-cp-secYield-footNote">
                          {{yieldNote.footnoteCode}} <span class="hide-text-screenreader-only"> SEC yield footnote code</span></a>
                        </h4>&nbsp;
                </h4>
                <p class="caption2 rps-paragraph-three rps-grey" data-rpa-tag-id="pr-cp-secYield-asOfDate">as of {{ priceModel.price.currentPrice.yield.asOfDate | ESTPipe }}</p>
                </h4>

                <h4 *ngIf="priceModel.profile?.category ==='Real Estate' && priceModel?.profile?.isInternalFund">
                  <a [attr.href]="noteUrl" class="primary-independent secYield-note">Note</a>
              </h4>
              <h4 *ngIf="priceModel?.profile?.category ==='Real Estate' && priceModel?.profile?.isExternalFund">
                <a class="mdashColor">{{priceModel.price.currentPrice.yield?.yieldPct}}{{priceModel.price.currentPrice.yield?.yieldPct?'%':'&mdash;'}}</a>

                  <h4 class="cell-size db-data rps-heading-four" *ngIf="priceModel.price.currentPrice.yield?.yieldPct && priceModel?.profile?.category ==='Real Estate' && priceModel?.profile?.isExternalFund">
              <p class="caption2 rps-paragraph-three rps-grey" data-rpa-tag-id="pr-cp-secYield-asOfDate">as of {{ priceModel.price.currentPrice.yield.asOfDate | ESTPipe }}</p>
              </h4>
              </h4>

            </div>
        </div>

        <div class="col-lg-4 col-sm-2 col-xs-2 col-6" *ngIf="priceModel.profile.fundFact?.isMoneyMarket && !priceModel.profile?.is529">
            <div class="cell">

                <p class="rps-paragraph-two"><a role="button" tabindex="0" class="marketPriceLink dialog-button" (click)="setDialogInfo('Daily market value','','');closingPriceModalDialog.openModalDialog();" href="javascript:void(0)">Daily market value</a></p>
                <h4 class="rps-heading-four" data-rpa-tag-id="pr-cp-dailyMkt-value">{{priceModel.price.currentPrice.dailyPrice.dailyMarketValue?
                    (priceModel.price.currentPrice.dailyPrice.dailyMarketValue.price| currency:'USD':'symbol':'1.4-4') : '&mdash;'}}
                </h4>
                <p class="caption2 rps-paragraph-three rps-grey" *ngIf="priceModel.price.currentPrice.highLow.regular">as of {{ priceModel.price.currentPrice.dailyPrice.dailyMarketValue.asOfDate
                    | ESTPipe }}</p>
            </div>
        </div>

    </div>


</div>

<c11n-modal-dialog modalId="closingPriceModal" [headingText]="profileLongName" #closingPriceModalDialog>
    <div c11n-modal-dialog-body class="closing-price-gap">
        <p *ngIf="!SecyieldFlag" [innerHTML]="noteText"></p>
        <p *ngIf="SecyieldFlag" [innerHTML]="noteText"></p>
     </div>
</c11n-modal-dialog>
